import type React from 'react';

import { TeamMembers } from './components/TeamMembers';

export const PageBody: React.FC = () => {
	return (
		<div className="container">
			<TeamMembers />
		</div>
	);
};
